import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './mission-dashboard.module.scss';

export const MissionDashboardSkeleton = () => {
  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.leftHeader}>
            <Skeleton height={24} width={24} borderRadius={8} />
            <div className={styles.missionInfo}>
              <Skeleton height={32} width="40%" borderRadius={8} />
              <Skeleton height={16} width="30%" borderRadius={8} />
              <Skeleton height={16} width="25%" borderRadius={8} />
            </div>
          </div>
          <div />
          <div className={styles.rightHeader}>
            <Skeleton height={72} width="100%" borderRadius={16} />
          </div>
        </div>

        <div className={styles.dataBoxes}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} height={96} width="100%" borderRadius={14} />
          ))}
        </div>

        <div className={styles.detailsGrid}>
          <div className={styles.mainBox}>
            <Skeleton height="100%" width="100%" borderRadius={14} />
          </div>
          <div className={styles.topRightBox}>
            <Skeleton height={120} width="100%" borderRadius={14} />
            <div className={styles.topRightItems}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Skeleton
                  key={index}
                  height="100%"
                  width="100%"
                  borderRadius={14}
                />
              ))}
            </div>
          </div>
          <div className={styles.bottomRightBox}>
            <Skeleton height="100%" width="100%" borderRadius={14} />
          </div>
        </div>
      </div>
    </div>
  );
};
